import { IForecastTimelineTableItem } from '@/coreDomainsModule/entities/forecastTimeline';
import { ICustomerForecastTimeline } from '../domains/entities/customerForecastTimeline';
import { ForecastTimelineService } from '@/coreDomainsModule/services/forecastTimelineService';

/**
 * 客先内示遍歴情報をテーブルUI用に変換する
 */
export class CustomerForecastTimelineTableStateAdapter {
  /**
   * 客先内示遍歴情報をテーブルUI用に変換する
   * @param state - 客先内示遍歴情報
   */
  public static adapt(state: ICustomerForecastTimeline): Set<IForecastTimelineTableItem> {
    const customerForecasts = state.customerForecasts;
    const salesResults = state.salesResults;
    const tableItems: Set<IForecastTimelineTableItem> = new Set();

    // まず販売実績を追加
    salesResults.forEach((salesResult) => {
      tableItems.add({
        verticalYearMonth: salesResult.targetYearMonth,
        horizontalYearMonth: salesResult.targetYearMonth,
        amount: salesResult.amount,
      });
    });

    // 客先内示を追加。内示用のセルでない場合は追加しない
    customerForecasts.forEach((customerForecast) => {
      const receivedYearMonth = customerForecast.receivedYearMonth;
      const targetYearMonth = customerForecast.targetYearMonth;
      if (ForecastTimelineService.getTableCellType(receivedYearMonth, targetYearMonth) === 'forecast') {
        tableItems.add({
          verticalYearMonth: receivedYearMonth,
          horizontalYearMonth: targetYearMonth,
          amount: customerForecast.amount,
        });
      }
    });

    return tableItems;
  }
}
